import { useUnit } from 'effector-react';
import { $changeEventsCursor } from '@nx-frontend/shared/store/change-events-store';
import { ChangeEventType, ChangeItem } from '@nx-frontend/shared/types';

export const useGetPortalChanges = () => {
  const [{ history }] = useUnit([$changeEventsCursor]);

  return history.reduce<ChangeItem[]>(
    (acc, { type, meta }) => {
      if (!meta) {
        return acc;
      }
      const { pageTitle: title, path } = meta;
      const key = [
        ChangeEventType.ADD_MENU_ITEM,
        ChangeEventType.DELETE_MENU_ITEM,
        ChangeEventType.UPDATE_MENU_ITEM,
        ChangeEventType.ADD_NODE,
        ChangeEventType.DELETE_NODE,
      ].includes(type)
        ? 'navigation'
        : [ChangeEventType.UPDATE_SEARCH_ANALYTICS_SETTINGS].includes(type)
        ? 'settings'
        : [ChangeEventType.UPDATE_THEME_SETTINGS].includes(type)
        ? 'theme'
        : path;

      let index = acc.findIndex((item) => item.key === key);
      if (index === -1) {
        acc.push({
          key: path,
          path,
          title,
          changes: 0,
        });
        index = acc.length - 1;
      }
      acc[index].changes++;
      return acc;
    },
    [
      {
        title: 'Settings',
        key: 'settings',
        changes: 0,
      },
      {
        title: 'Navigation',
        key: 'navigation',
        changes: 0,
      },
      {
        title: 'Theme',
        key: 'theme',
        changes: 0,
      },
    ]
  );
};
